// Phase 1A Phase 9C.2 — Readiness icon definitions.
//
// 10 readiness glyphs. Clocks / checks / refresh-arrows / dots — the
// vocabulary of pre-computation freshness. NEVER a "live monitoring"
// pulse. NEVER a green "all systems go" gradient.

import type { IconDef } from "./icon-types.ts";

export const READINESS_ICONS: Record<string, IconDef> = {
  "readiness.preliminary": {
    key: "readiness.preliminary",
    shapes: [{ type: "circle", cx: 12, cy: 12, r: 7 }],
  },
  "readiness.complete": {
    key: "readiness.complete",
    shapes: [
      { type: "circle", cx: 12, cy: 12, r: 7 },
      { type: "polyline", points: "9,12 11,14 15,10" },
    ],
  },
  "readiness.freshness_checked": {
    key: "readiness.freshness_checked",
    shapes: [
      { type: "circle", cx: 12, cy: 12, r: 7 },
      { type: "polyline", points: "12,8 12,12 14,13" },
      { type: "polyline", points: "16,15 18,17 21,14" },
    ],
  },
  "readiness.stale": {
    key: "readiness.stale",
    shapes: [
      { type: "circle", cx: 12, cy: 12, r: 7 },
      { type: "polyline", points: "12,8 12,12 14,13" },
      { type: "line", x1: 6, y1: 18, x2: 18, y2: 6 },
    ],
  },
  "readiness.expired": {
    key: "readiness.expired",
    shapes: [
      { type: "circle", cx: 12, cy: 12, r: 7 },
      { type: "line", x1: 9, y1: 9, x2: 15, y2: 15 },
      { type: "line", x1: 15, y1: 9, x2: 9, y2: 15 },
    ],
  },
  "readiness.recheck_needed": {
    key: "readiness.recheck_needed",
    shapes: [
      { type: "path", d: "M5 12 A7 7 0 1 1 12 19" },
      { type: "polyline", points: "9,19 12,19 12,16" },
      { type: "polyline", points: "10,9 12,11 14,9" },
    ],
  },
  "readiness.analysis_ready": {
    key: "readiness.analysis_ready",
    shapes: [{ type: "polygon", points: "12,5 19,12 12,19 5,12", filled: true }],
  },
  "readiness.lineup_pending": {
    key: "readiness.lineup_pending",
    shapes: [
      { type: "circle", cx: 6, cy: 12, r: 1.4, filled: true },
      { type: "circle", cx: 12, cy: 12, r: 1.4, filled: true },
      { type: "circle", cx: 18, cy: 12, r: 1.4, filled: true },
    ],
  },
  "readiness.result_logged": {
    key: "readiness.result_logged",
    shapes: [
      { type: "rect", x: 5, y: 5, width: 14, height: 14, rx: 1, filled: true },
      { type: "polyline", points: "9,12 11,14 15,10", strokeWidth: 2.4 },
    ],
  },
  "readiness.pattern_updated": {
    key: "readiness.pattern_updated",
    shapes: [
      { type: "rect", x: 5, y: 5, width: 6, height: 6 },
      { type: "rect", x: 13, y: 5, width: 6, height: 6 },
      { type: "rect", x: 5, y: 13, width: 6, height: 6 },
      { type: "polyline", points: "16,16 19,16 19,13" },
      { type: "path", d: "M13 19 L19 13" },
    ],
  },
};
